import { render, staticRenderFns } from "./PilihHakAkses.vue?vue&type=template&id=35410ea7"
import script from "./PilihHakAkses.vue?vue&type=script&lang=js"
export * from "./PilihHakAkses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports